export enum RelevanceRatingColor {
  relevant = '#3481CF',
  notRelevant = '#DB6B77',
  toClarify = '#D9BC82',
  toMonitor = '#92B3AD',
  notRated = '#345890'
}
